import { render } from "./CompLoading.vue?vue&type=template&id=7a5b2a3c&scoped=true"
const script = {}

import "./CompLoading.vue?vue&type=style&index=0&id=7a5b2a3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a5b2a3c"]])

export default __exports__